export const appConfig = {
  name: String(process.env.REACT_APP_NAME || 'HSDB'),
  url: String(process.env.REACT_APP_URL || 'http://127.0.0.1:3000'),
  apiUrl: String(process.env.REACT_APP_API_URL || 'http://127.0.0.1:3000/api'),
  pageSize: 24,
}
